// extracted by mini-css-extract-plugin
export default {"search_medicine_input":"styles_search_medicine_input__2ffoN","spin":"styles_spin__8Mr5c"};